import axios from "axios";
import { API_REQUEST_TIMEOUT_MS } from "../auth/authRequest";

const POLL_INTERVAL_MS = 600;
const POLL_MAX_ATTEMPTS = 30;

/** Full vehicle booking payload — not the async `{ status: "completing" }` stub. */
export function isVehicleBookingReady(data) {
  return !!(data?.booking_id && data?.start_date && data?.end_date && data?.status !== "completing");
}

/**
 * Confirm a Stripe Checkout session and wait for background booking finalization.
 * The API may return `{ status: "completing", booking_id }` before the booking doc exists.
 */
export async function completeVehicleStripeCheckout(apiBase, sessionId) {
  let lastCompleting = null;

  for (let attempt = 0; attempt < POLL_MAX_ATTEMPTS; attempt += 1) {
    try {
      const res = await axios.post(
        `${apiBase}/payments/stripe/complete`,
        { session_id: sessionId },
        { withCredentials: true, timeout: API_REQUEST_TIMEOUT_MS },
      );
      if (isVehicleBookingReady(res.data)) {
        return res.data;
      }
      if (res.data?.status === "completing" && res.data?.booking_id) {
        lastCompleting = res.data;
        await sleep(POLL_INTERVAL_MS);
        continue;
      }
      return res.data;
    } catch (e) {
      const detail = e.response?.data?.detail;
      const status = e.response?.status;
      if (status === 409 && detail === "completion_in_progress") {
        await sleep(POLL_INTERVAL_MS);
        continue;
      }
      throw e;
    }
  }

  const err = new Error("Booking confirmation is taking longer than expected. Please retry.");
  err.code = "completion_timeout";
  if (lastCompleting?.booking_id) {
    err.bookingId = lastCompleting.booking_id;
  }
  throw err;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
